module.exports = "/_next/static/files/535411767a4a4ac140bb7960b0a49c05.svg";